import { TStudioProtocolScheme } from '@rbx/studio';

const studioProtocolScheme = (
  process.env.environment === 'production' ? 'roblox-studio' : 'roblox-studio-sitetest1'
) as TStudioProtocolScheme;

export default studioProtocolScheme;
